import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 via-blue-50 to-blue-900 overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/6a393ae4653a5ba875c49f112e186fdd.jpg')] bg-cover bg-center opacity-20"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
      
      <div className="relative w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-left">
            <div className="inline-flex items-center px-4 py-2 bg-white/90 backdrop-blur-sm rounded-full border border-blue-600 mb-6">
              <i className="ri-shield-check-line text-blue-600 mr-2"></i>
              <span className="text-sm font-medium text-gray-900">Distributore Autorizzato B2B</span>
            </div>
            
            <h1 className="text-5xl md:text-7xl font-extrabold text-gray-900 mb-6 leading-tight">
              Tecnologia<br />
              <span className="text-blue-600">All'Ingrosso</span><br />
              Per Professionisti
            </h1>
            
            <p className="text-xl text-gray-700 mb-8 max-w-xl">
              Computer, Smartphone e Software per Rivenditori e Aziende
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/contatti"
                className="inline-flex items-center justify-center bg-blue-600 text-white px-8 py-4 rounded-xl text-lg font-semibold hover:bg-blue-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Richiedi Listino Prezzi
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
              <Link
                to="/prodotti"
                className="inline-flex items-center justify-center bg-transparent border-2 border-blue-600 text-blue-600 px-8 py-4 rounded-xl text-lg font-semibold hover:bg-blue-600 hover:text-white transition-all whitespace-nowrap cursor-pointer"
              >
                Catalogo Prodotti
                <i className="ri-download-line ml-2"></i>
              </Link>
            </div>
          </div>
          
          <div className="relative">
            <div className="space-y-4">
              <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-xl p-6 transform hover:scale-105 transition-transform">
                <div className="flex items-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full mr-4">
                    <i className="ri-phone-line text-2xl text-blue-600"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600 font-medium">Assistenza Immediata</p>
                    <a href="tel:+393508628049" className="text-lg font-bold text-gray-900 hover:text-blue-600 cursor-pointer">
                      350 862 8049
                    </a>
                  </div>
                </div>
              </div>
              
              <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-xl p-6 transform hover:scale-105 transition-transform">
                <div className="flex items-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-full mr-4">
                    <i className="ri-mail-line text-2xl text-green-600"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600 font-medium">Email Ordini</p>
                    <a href="mailto:ordini.amacasrl@gmail.com" className="text-base font-bold text-gray-900 hover:text-green-600 cursor-pointer break-all">
                      ordini.amacasrl@gmail.com
                    </a>
                  </div>
                </div>
              </div>
              
              <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-xl p-6 transform hover:scale-105 transition-transform">
                <div className="flex items-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-purple-100 rounded-full mr-4">
                    <i className="ri-map-pin-line text-2xl text-purple-600"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600 font-medium">Sede Operativa</p>
                    <p className="text-base font-bold text-gray-900">Casandrino (NA) - Spedizioni Nazionali</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="mt-8 rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20technology%20products%20composition%20featuring%20modern%20laptop%20smartphone%20and%20tablet%20devices%20arranged%20on%20clean%20white%20surface%20minimalist%20product%20photography%20with%20soft%20shadows%20high%20end%20electronics%20display%20simple%20neutral%20background%20emphasizing%20premium%20quality%20tech%20gadgets%20commercial%20product%20shot%20style&width=800&height=600&seq=amaca-hero-products-002&orientation=landscape"
                alt="Prodotti Tecnologici Amaca"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
